import * as React from "react";
import NotificationType from "./NotificationType";
import { useSessionState } from "./useSessionState";
import { useCallback, useEffect } from "react";

interface Notification {
	headline: string;
	message?: string;
	type: NotificationType;
	time?: Date;
}

export interface NotificationContextInterface {
	notification: Notification,
	addNotification: (notification: Notification) => void,
	removeNotification: () => void
}

export const NotificationContext = React.createContext<NotificationContextInterface | null>({
	notification: null,
	addNotification: () => { },
	removeNotification: () => { }
});

/*@ts-ignore*/
function NotificationProvider({ children }) {

	const storageKey = 'notifications';
	const [notification, setNotification] = useSessionState(storageKey, null, false, true);
	const removeNotification = () => {
		setNotification(null);
		sessionStorage.removeItem(storageKey);
	};
	let notificationTimer: any;

	const addNotification = (notification: Notification) => {
		notification.time = new Date();
		setNotification(notification);
		notificationTimer = setTimeout(() => {
			sessionStorage.removeItem(storageKey);
		}, 300);
	};

	const contextValue = {
		notification,
		addNotification: useCallback((notification: Notification) => addNotification(notification), []),
		removeNotification: useCallback(() => removeNotification(), [])
	};

	useEffect(() => {
		return () => {
			if (notificationTimer) {
				clearTimeout(notificationTimer);
			}
		}
	}, []);

	return (
		<NotificationContext.Provider value={contextValue}>
			{children}
		</NotificationContext.Provider>
	);
}

export default NotificationProvider;
